import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalDelete",
  tabindex: "-1",
  "aria-labelledby": "createPost",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header mb-3" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "px-3 pt-4 pb-1 text-center" }
const _hoisted_8 = {
  key: 0,
  class: "px-3 pb-4 text-center"
}
const _hoisted_9 = { class: "d-flex align-items-center justify-content-center pb-3" }

import { translate } from '@/languages/i18n'
import ModalDeleteSuccess from './ModalDeleteSuccess.vue'
import { ref, onMounted } from 'vue'
import Button from '@/components/button/index.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { USER_POST_STORE } from '@/store/constants'
import userPostService from '@/services/user-post.services'
import { omit } from 'lodash'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  post: {},
  contentType: Number,
},
  emits: ['hiddenDeleteModal'],
  setup(__props, { emit }) {

const props = __props


const checkDelete = ref(true)
const store = useStore()
const route = useRoute()
const modalDeleteSuccess = ref()
const onSubmit = ref(false)


onMounted(() => {
  //2022/12/1 TrungNT Fix for UAT#5678: CT10 (Ph2-R20221222)
  modalDeleteSuccess.value = new Modal(document.getElementById('modalDeleteSuccess'))
})

const handleDelete = async (): void => {
  onSubmit.value = true
  const queryData = {
    chatroom_id: route.params.id,
    params: { ...route.query, page_of_number: route.query?.page_of_number || 30 },
    operational_posts: route.path.includes('operational_posts'),
  }
  try {
    const data = await userPostService.deleteUserPosts(props?.post?.id, true)
    if (data.data?.success) {
      checkDelete.value = true
      if (queryData.operational_posts) {
        store.dispatch(USER_POST_STORE.ACTIONS.GET_OPERATIONAL_POST, omit(queryData, 'operational_posts'))
      } else {
        store.dispatch(USER_POST_STORE.ACTIONS.GET_POST, omit(queryData, 'operational_posts'))
      }
    } else {
      checkDelete.value = false
    }
  } catch (error) {
    checkDelete.value = false
    console.log(error)
  }

  //2022/12/1 TrungNT Fix for UAT#5678: CT10 (Ph2-R20221222)
  onSubmit.value = false
  emit('hiddenDeleteModal')
  modalDeleteSuccess.value.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('titleConfirmDeletePost')), 1),
            _hoisted_6
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString('投稿' + '「' + props?.post?.title + '」') + _toDisplayString(_unref(translate)('deleteGroupName')), 1),
          (__props.contentType === 5)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(translate)('CK10NoteDeletePostAutomatic')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Button, {
              title: _unref(translate)('cancel'),
              class: "m-w-unset me-2",
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"]),
            _createVNode(Button, {
              onClick: handleDelete,
              title: _unref(translate)('deleteButton'),
              class: "m-w-unset",
              type: 'secondary',
              disabled: onSubmit.value
            }, null, 8, ["title", "disabled"])
          ])
        ])
      ])
    ]),
    _createVNode(ModalDeleteSuccess, { checkDelete: checkDelete.value }, null, 8, ["checkDelete"])
  ], 64))
}
}

})